<ng-container
  [ngTemplateOutlet]="rendererTemplate"
  [ngTemplateOutletContext]="{
    $implicit: config(),
    cols: '1',
    level: 1,
    parentName: ''
  }"
>
</ng-container>

<ng-template
  #rendererTemplate
  let-config
  let-cols="cols"
  let-level="level"
  let-parentName="parentName"
>
  <div class="flex-1 grid grid-cols-{{ cols }} gap-4">
    @for (item of config; track item) {
      <div class="flex">
        @switch (item.type) {
          @case ("custom") {
            <snt-report-form-renderer-custom
              #renderer
              [item]="item"
              (action)="action.emit($event)"
              (config)="item.config = $event; onValue()"
            ></snt-report-form-renderer-custom>
          }
          @case ("tab") {
            <snt-report-form-renderer-tab
              #renderer
              [item]="item"
              [templateOutlet]="rendererTemplate"
              [readOnly]="readOnly"
            >
            </snt-report-form-renderer-tab>
          }
          @case ("group") {
            <snt-report-form-renderer-group-vertical
              #renderer
              [item]="item"
              [templateOutlet]="rendererTemplate"
              [level]="level"
              [parentName]="parentName"
              [readOnly]="readOnly"
            ></snt-report-form-renderer-group-vertical>
          }
          @case ("group-vertical") {
            <snt-report-form-renderer-group-vertical
              #renderer
              [item]="item"
              [templateOutlet]="rendererTemplate"
              [level]="level"
              [parentName]="parentName"
              [readOnly]="readOnly"
            ></snt-report-form-renderer-group-vertical>
          }
          @case ("group-horizontal") {
            <snt-report-form-renderer-group-horizontal
              #renderer
              [item]="item"
              [templateOutlet]="rendererTemplate"
              [level]="level"
              [parentName]="parentName"
              [readOnly]="readOnly"
            ></snt-report-form-renderer-group-horizontal>
          }
          @case ("table") {
            <snt-report-form-renderer-grid
              #renderer
              [item]="item | asGridValue"
              [dataSource]="dataSource"
              [level]="level"
              [parentName]="parentName"
            ></snt-report-form-renderer-grid>
          }
          @case ("image") {
            <snt-report-form-renderer-image
              #renderer
              [item]="item | asImageValue"
              [level]="level"
              [parentName]="parentName"
              [readOnly]="readOnly"
              (value)="onValue()"
              (uploadStarted)="uploadStarted.emit()"
              (uploadEnded)="uploadEnded.emit()"
            ></snt-report-form-renderer-image>
          }
          @case ("text") {
            <snt-report-form-renderer-text
              #renderer
              [item]="item | asTextValue"
              [level]="level"
              [parentName]="parentName"
              [readOnly]="readOnly"
              (value)="onValue()"
            ></snt-report-form-renderer-text>
          }
          @case ("check") {
            <snt-report-form-rederer-check
              #renderer
              [item]="item | asTextValue"
              [level]="level"
              [parentName]="parentName"
              [readOnly]="readOnly"
              (value)="onValue()"
            ></snt-report-form-rederer-check>
          }
          @case ("checklist") {
            <snt-report-form-renderer-checklist
              #renderer
              [item]="item | asTextValue"
              [level]="level"
              [parentName]="parentName"
              [readOnly]="readOnly"
              (value)="onValue()"
            ></snt-report-form-renderer-checklist>
          }
          @case ("textarea") {
            <snt-report-form-renderer-textarea
              #renderer
              [item]="item | asTextValue"
              [level]="level"
              [parentName]="parentName"
              [readOnly]="readOnly"
              (value)="onValue()"
            ></snt-report-form-renderer-textarea>
          }
          @case ("selectbox") {
            <snt-report-form-renderer-selectbox
              #renderer
              [item]="item | asSelectboxValue"
              [level]="level"
              [parentName]="parentName"
              [readOnly]="readOnly"
              (value)="onValue()"
            ></snt-report-form-renderer-selectbox>
          }
          @case ("empty") {
            <snt-report-form-renderer-empty
              #renderer
            ></snt-report-form-renderer-empty>
          }
          @case ("customer-signature") {
            <snt-report-form-renderer-customer-signature
              #renderer
            ></snt-report-form-renderer-customer-signature>
          }
          @case ("signature") {
            <snt-report-form-renderer-signature
              #renderer
              [item]="item | asSignatureValue"
              [healthRecord]="healthRecord"
              [dataSource]="dataSource"
              [level]="level"
              [parentName]="parentName"
              (value)="onValue()"
            ></snt-report-form-renderer-signature>
          }
          @case ("spacer") {
            <snt-report-form-renderer-spacer
              #renderer
              [item]="item | asSpacerConfig"
              [level]="level"
              [parentName]="parentName"
              class="-mx-2"
            ></snt-report-form-renderer-spacer>
          }
          @case ("title") {
            <snt-report-form-renderer-title
              #renderer
              [item]="item | asTitleValue"
              [level]="level"
              [parentName]="parentName"
              (value)="onValue()"
            ></snt-report-form-renderer-title>
          }
        }
      </div>
    }
  </div>
</ng-template>
